import Provider from "providers/CartProvider";

// You can delete this file if you're not using it
import "./src/styles/style.scss";

export const wrapRootElement = Provider;
